import { LocalizationService } from '@abp/ng.core';
import { ConfirmationService } from '@abp/ng.theme.shared';
import { inject, Injectable } from '@angular/core';
import { localizeWithFallback } from '../utils/localization-utils';

type CancelConfirmationOptions = {
  messageKey?: string;
  titleKey?: string;
  type?: 'success' | 'warning' | 'error' | 'info';
};

@Injectable({
  providedIn: 'root',
})
export class ZnConfirmation {
  private readonly confirmationService = inject(ConfirmationService);
  private readonly localizationService = inject(LocalizationService);

  showCancelConfirmation(options?: CancelConfirmationOptions) {
    const messageKey = options?.messageKey ?? 'LanguageService::ConfirmCancelChanges';
    const titleKey = options?.titleKey ?? 'LanguageService::ConfirmCancelChangesTitle';
    const type = options?.type ?? 'warning';

    return this.confirmationService.show(
      localizeWithFallback(
        this.localizationService,
        messageKey,
      ),
      localizeWithFallback(
        this.localizationService,
        titleKey,
      ),
      type,
      {
        iconTemplate: '<i class="bi bi-exclamation-octagon-fill"></i>',
        yesText: localizeWithFallback(
          this.localizationService,
          'LanguageService::Option:Yes',
        ),
        cancelText: localizeWithFallback(
          this.localizationService,
          'LanguageService::Option:No',
        ),
      },
    );
  }
}
